"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.inputMixin = exports.inputHoverMixin = exports.inputFocusMixin = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var Cell_1 = require("../Cell");
var systemProps = (0, styled_system_1.compose)(styled_system_1.border, styled_system_1.flexbox, styled_system_1.space, styled_system_1.typography, styled_system_1.layout, styled_system_1.color);
exports.inputFocusMixin = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  ::placeholder {\n    text-decoration: underline;\n  }\n"], ["\n  ", ";\n\n  ::placeholder {\n    text-decoration: underline;\n  }\n"])), Cell_1.cellFocusMixin);
exports.inputHoverMixin = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ::placeholder {\n    text-decoration: underline;\n  }\n"], ["\n  ::placeholder {\n    text-decoration: underline;\n  }\n"])));
exports.inputMixin = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  appearance: none;\n  border-radius: 0;\n  margin: 0;\n  transition: box-shadow 250ms ease;\n  ", "\n\n  background-color: transparent;\n\n  ", "\n  &:focus {\n    ", "\n  }\n\n  ", "\n  &:hover {\n    ", "\n  }\n\n  &:autofill {\n    font-size: 1rem;\n  }\n"], ["\n  appearance: none;\n  border-radius: 0;\n  margin: 0;\n  transition: box-shadow 250ms ease;\n  ", "\n\n  background-color: transparent;\n\n  ", "\n  &:focus {\n    ", "\n  }\n\n  ", "\n  &:hover {\n    ", "\n  }\n\n  &:autofill {\n    font-size: 1rem;\n  }\n"])), systemProps, function (_a) {
    var focus = _a.focus;
    return focus && exports.inputFocusMixin;
}, exports.inputFocusMixin, function (_a) {
    var hover = _a.hover;
    return hover && exports.inputHoverMixin;
}, exports.inputHoverMixin);
exports.Input = styled_components_1.default.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.inputMixin);
exports.Input.defaultProps = __assign({}, Cell_1.CELL);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Input.js.map